'use strict';
import { isFeatureOn } from '@/utils/features';

const STATE_KEY = 'state';
const STATE_OVERRIDE_KEY = 'state_override';

const simplifyText = (name) => {
  return name
    .replace(/\s+/g, ' ') // remove extra whitespaces
    .replace(/[&\/\\#,+()$~%.'":*?<>{}-]/g, '') //remove special chars
    .trim()
    .toLowerCase()
}


export function isUserStateSupportedBySeller({ seller, userState }) {
  const statesLicenses = seller.state_licenses || []
  const stateAbb = getStateAbbreviation(userState)
  return stateAbb && statesLicenses.includes(stateAbb)
}

export function getStateAbbreviation(stateName) {
  if (!stateName) { 
    return null;
  }
  if (statesNames[stateName.trim().toUpperCase()]) {
    return stateName.trim().toUpperCase(); // stateName is alrady the abbreviation
  }
  const stateNameToCode = {};
  for (const abbreviation in statesNames) {
    const stateName = statesNames[abbreviation].toLowerCase().trim();
    stateNameToCode[stateName] = abbreviation;
  }
  const standardStateName = simplifyText(stateName);
  const abbreviation = stateNameToCode[standardStateName];
  return abbreviation;
}

export function getSelectedStateName() {
  return getStateName(getSelectedState());
}

export function setUserOverrideDefaultState() {
  if (typeof window !== "undefined") {
    localStorage.setItem(STATE_OVERRIDE_KEY, true);
  }
}
export function isUserOverrideDefaultState() {
  return localStorage && localStorage.getItem(STATE_OVERRIDE_KEY) === 'true' ? true : false;
}
export function getSelectedState() {
  // TODO fix localStorage
  // return (localStorage && localStorage.getItem(STATE_KEY)) || getSupportedStates()[0];
  return getSupportedStates()[0];
}

function getStatesLicensesForProducer(producer) {
  return producer?.shippedFromProducer
    ? producer?.shippedFromProducer?.statesLicenses || []
    : producer?.statesLicenses;
}
export function canProducerShipToSelectedState(producer) {
  const state = getSelectedState();
  const statesLicenses = getStatesLicensesForProducer(producer);
  const validState = statesLicenses ? statesLicenses.indexOf(state) > -1 : undefined;
  return validState;
}

export function separateBrandsByStateShipment(brands) {
  const state = getSelectedState();
  const validBrands = [];
  const notValidBrands = [];
  (brands || []).forEach((brand) => {
    const statesLicenses = getStatesLicensesForProducer(brand);
    const validState = statesLicenses.indexOf(state) > -1;
    if (validState) {
      validBrands.push(brand);
    } else {
      notValidBrands.push(brand);
    }
  });
  return [validBrands, notValidBrands];
}

export function setSelectedState(state) {
  if (typeof window !== "undefined") {
    localStorage.setItem(STATE_KEY, state);
  }
}

export function getSupportedStates() {
  const supportedStates = ['NY'];
  if (isFeatureOn('NEXT_PUBLIC_SUPPORT_CALIFORNIA')) {
    supportedStates.push('CA');
  }
  
  return supportedStates;
}

export function getAllStates() {
  return Object.keys(statesNames);
}

export function getStateName(abbreviation) {
  return abbreviation && statesNames[abbreviation.toUpperCase()];
}

const statesNames = {
  AL: 'Alabama',
  AK: 'Alaska',
  AS: 'American Samoa',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DE: 'Delaware',
  DC: 'District of Columbia',
  FM: 'Federated States of Micronesia',
  FL: 'Florida',
  GA: 'Georgia',
  GU: 'Guam',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MH: 'Marshall Islands',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  MP: 'Northern Mariana Islands',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PW: 'Palau',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VI: 'Virgin Island',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};
